import {popupCreateUpdateProject} from "../common/PopupForms";
import Helper from "../common/Helper";

export default function tableProjects(HelperTable) {

    const selectorTable = '#table-projects';
    const elTable = $(selectorTable)

    if (!elTable?.length) {
        return;
    }

    const canCreate = Helper.userCan('create_project')
    const canEdit = Helper.userCan('edit_project')
    const canDelete = Helper.userCan('delete_project')
    const canViewReports = Helper.userCan('view_reports')
    const isManager = ESR.Helper.isManager();
    const colStatusIndex = canViewReports ? 4 : 3;
    const colManagerIndex = canViewReports ? 3 : 2;

    const columnRaport = canViewReports ? [{
        label: 'Raport',
        data: 'id',
        orderable: false,
        className: 'no-export',
        width: '80px',
        render: (data, type, row) => {
            if (type === 'display') {
                return `<a class="btn-action" href="${ESR.Helper.getProjectReportUrl(row.slug)}">Raport</a>`;
            }
            return data;
        }
    }] : [];

    const columns = [
        {
            label: ESR.lang.id,
            data: 'id',
            orderable: true,
        },
        {
            label: ESR.lang.project_title,
            data: 'post_title',
            orderable: true,
            render: (data, type, row) => {

                if (type === 'display') {
                    return `<a href="${ESR.Helper.getProjectUrl(row.slug)}">${row.post_title}</a>`;
                    ;
                } else if (type === 'filter') {
                    return row.post_title;
                }

                return data;
            }
        },
        ...columnRaport,
        {
            label: ESR.lang.manager,
            data: 'manager',
            className: 'min-desktop',
            render: function (data, type, row) {
                if (type === 'display') {
                    return row.manager.name;
                } else if (type === 'filter') {
                    return row.manager.id + ' ' + row.manager.name;
                }

                return data;
            }
        },
        {
            label: ESR.lang.status,
            data: 'post_status',
            className: 'min-desktop',
            width: '80px',
            render: (data, type, row) => {

                if (type === 'display') {
                    return ESR.lang['status_' + row.post_status]
                } else if (type === 'filter') {
                    return row?.post_status
                }

                return data;
            }
        },


    ];


    if (canCreate) {
        columns.push({
            label: ESR.lang.created,
            data: 'date',
            className: 'min-desktop',
            orderable: true,
        })

        columns.push({
            label: ESR.lang.updated,
            data: 'updated',
            className: 'min-desktop',
            orderable: true,
        })
    }

    const myTableHeader = HelperTable.createRowHeader(columns);
    elTable.append(myTableHeader)


    let toolbarButtons = [HelperTable.btnColvis()];

    if (canCreate) {
        function callbackBtnAdd(e) {
            e.preventDefault();
            popupCreateUpdateProject({}, ESR.lang.add);
        }

        toolbarButtons.push(HelperTable.btnAdd(e => callbackBtnAdd(e)))
    }

    if (canEdit) {
        function callbackBtnEdit(e) {
            e.preventDefault();

            const elRow = table.row('.selected');

            if (!elRow.node()) {
                // "No row selected."
                return;
            }

            popupCreateUpdateProject(elRow.data(), ESR.lang.save);
        }

        toolbarButtons.push(HelperTable.btnEdit(e => callbackBtnEdit(e)))
    }

    if (canDelete) {
        function callbackBtnRemove(e) {
            e.preventDefault();

            const elRow = table.row('.selected');

            if (!elRow.node()) {
                // "No row selected."
                return;
            }

            const rowData = elRow.data();

            ESR.Popup.delete({
                title: rowData.title,
                html: `<p>Toate <b>datele</b> și <b>rapoartele</b> vor fi șterse definitiv, doriți să ștergeți ?</p`,
                action: 'esr_trash_project',
                id: rowData.id
            })
        }

        toolbarButtons.push(HelperTable.btnRemove(e => callbackBtnRemove(e)))
    }

    const table = new DataTable(selectorTable, {
        responsive: true,
        select: false,
        data: window.tableData,
        columns: columns,
        stateSave: false,
        displayLength: 20,
        order: [
            [0, 'dsc']
        ],
        processing: false,
        serverSide: false,
        info: false,
        layout: {

            topStart: {
                buttons: toolbarButtons,
            },
            topEnd: {
                search: {
                    text: '',
                    placeholder: ESR.lang.search
                }
            },
            bottom: 'paging',
            bottomStart: null,
            bottomEnd: null
        },
        language: {
            emptyTable: ESR.lang.emptyTable,
        },
        initComplete: function () {
            const api = this.api();
            const state = api.state.loaded()

            const colStatus = api.column(colStatusIndex);

            const colStatusStateValue = state?.columns[colStatusIndex].search.search ?? '';
            const elSelectStatus = ESR.View.select({
                value: colStatusStateValue,
                class: 'select-status select-sm',
                name: 'status',
                placeholder: ESR.lang.status,
                options: [
                    {value: 'publish', label: ESR.lang.status_publish},
                    {value: 'finished', label: ESR.lang.status_finished}
                ]
            }).on('change', function () {
                colStatus.search($(this).val(), {exact: false}).draw();
            });

            $('.dt-layout-end').prepend(elSelectStatus)

            const colManager = api.column(colManagerIndex)
            let colManagerStateValue = state?.columns?.[colManagerIndex]?.search?.search;
            const optionsManagers = HelperTable.createColumnSelectOptions(colManager, 'id', 'name');

            if (isManager) {
                if (colManagerStateValue === undefined) colManagerStateValue = String(ESR.user.id);
                colManager.search(colManagerStateValue, {exact: false}).draw();
            }

            const elSelectManager = ESR.View.select({
                value: colManagerStateValue,
                placeholder: ESR.lang.all_managers,
                class: 'select-manager select-sm',
                name: 'manager',
                options: optionsManagers
            }).on('change', function () {
                colManager.search($(this).val(), {exact: false}).draw();
            });

            $('.dt-layout-end').prepend(elSelectManager)
        }
    });


    if (canCreate) {
        const btnRowEdit = table.buttons().container().find('.btn-row-edit')
        const btnRowRemove = table.buttons().container().find('.btn-row-remove')
        $('body').on('click', (e) => {
            HelperTable.onSelectRow(e, table, btnRowEdit, btnRowRemove)
        });
    }

}